export class HomeAutomationClient {
  constructor(httpClient, baseURL) {
    this.httpClient = httpClient;
    this.baseURL = `${baseURL}/home-automation-web`;
  }

  accessToken() {
    const url = `${this.baseURL}/auth/access-token`;

    return this.httpClient.request("post", url);
  }
}



// WEBPACK FOOTER //
// ./src/clients/BaanRueJaiClient/home-automation.js